import { useCallback } from "react";

import { config } from "utils/config.utils";
import { removeCookie } from "utils/cookies.utils";

export const useLogout = () => {
  const logout = useCallback(() => {
    removeCookie(config.session_cookie);
    window.location.replace("/");
  }, []);

  return logout;
};
